// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"App__wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = ./src/App.scss
// module chunks = 2